import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPage } from "@/features/legal/pages";

/** Public privacy policy (ALP-77): the URL entered in the Meta App Dashboard. No sign-in. */
export const Route = createFileRoute("/privacy")({
  head: () => ({ meta: [{ title: "Privacy policy · Malfak" }, { name: "description", content: "What Instagram data Malfak accesses, why, how long it is kept and how to delete it." }] }),
  component: PrivacyPage,
});
